const articles = [
    {
        title: "Iran: Scores Blinded as Security Forces Aim Guns at Protesters' Eyes",
        image: "article_1.jpeg",
        caption: "Protesters: “We aren't Afraid of the Darkness”",
        link: "https://google.com"
    },
    {
        title: "Iran: Scores Blinded as Security Forces Aim Guns at Protesters' Eyes",
        image: "article_1.jpeg",
        caption: "Protesters: “We aren't Afraid of the Darkness”",
        link: "https://google.com"
    },
    {
        title: "Iran: Scores Blinded as Security Forces Aim Guns at Protesters' Eyes",
        image: "article_1.jpeg",
        caption: "Protesters: “We aren't Afraid of the Darkness”",
        link: "https://google.com"
    },
    {
        title: "Iran: Scores Blinded as Security Forces Aim Guns at Protesters' Eyes",
        image: "article_1.jpeg",
        caption: "Protesters: “We aren't Afraid of the Darkness”",
        link: "https://google.com"
    },
    {
        title: "Iran: Scores Blinded as Security Forces Aim Guns at Protesters' Eyes",
        image: "article_1.jpeg",
        caption: "Protesters: “We aren't Afraid of the Darkness”",
        link: "https://google.com"
    }
]

export default articles